import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TipControllerService {
  private tipSubject = new Subject<string[] | undefined>();
  tip$ = this.tipSubject.asObservable();

  set(tip: string[] | undefined): void {
    this.tipSubject.next(tip);
  }
}
